import i18n from '../lib/i18n.js';

export const defs = {
    en : {
        values : {
            'header.title': 'Textbook Solutions for',
            'header.no-title' : 'Textbook Solutions',
            'problem.title' : 'Problem',
            'problem.single_solution' : 'Problem %{problem}',
            'problem.prev' : 'Prev',
            'problem.next' : 'Next',
            'no-solution.title' : 'There is no solution to this problem yet.',
            'no-solution.no-cta' : 'Please select another problem.',
            'no-solution.qa' : 'Get help from a Chegg subject expert.',
            'no-solution.ask-expert-btn' : 'Ask an expert',
            'step.title' : 'Step %{index}',
            'step.title-total' : 'of %{total}',
            'toolbar.name.empty' : '',
            'toolbar.hide-all-steps' : 'Hide all steps',
            'toolbar.show-all-steps' : 'Show all steps',
            'toolbar.toggle-on' : 'on',
            'toolbar.toggle-off' : 'off',
            'toc.chapter.name' : 'Chapter %{name}',
            'toc.problem.name' : 'Problem %{name}',
            'toc.loader.title' : 'Loading ...',
            'bookmark-tab.not-bookmarked' : 'Bookmark',
            'bookmark-tab.bookmarked' : 'Bookmarked',
            'bookmark-tab.bookmark-count-plural': '%{count} bookmarks',
            'bookmark-tab.bookmark-count-plural-display': '%{count}k bookmarks',
            'bookmark-tab.bookmark-count-single': '1 bookmark',
            'bookmark-tab.bookmark-label' : 'Bookmark tab. This solution has %{book}',
            'bookmark-tab.bookmark-label-no-bookmarks' : 'Bookmark tab. This solution has no bookmarks',
            'bookmark-tab.unbookmark-solution-description': 'Unbookmark this solution?',
            'bookmark-tab.bookmark-solution-description': 'Bookmark this solution?',
            'bookmark-tab.bookmark-solution-action' : 'You bookmarked this solution',
            'bookmark-tab.unbookmark-solution-action' : 'You unbookmarked this solution',
            'mobile-tab.text-solution-popup-description' : 'Message and data rates may apply. See more details (link to https://www.chegg.com/mobiledisclosures)',
            'mobile-tab.text-solution-aria-label' : 'Text the solution to your cell phone',
            'review-box.solution-clear-enough' : 'Was this solution helpful?',
            'review-box.thumbs-up-thanks' : 'Sweet! Glad to be of help!',
            'review-box.thumbs-up-after' : 'Many thanks for the thumbs up.',
            'review-box.thumbs-up-description' : '%{thumbup} people thought this solution was helpful. Give this solution a thumbs up',
            'review-box.thumbs-down-thanks' : 'Sorry. Sometimes, we make mistakes. Let us know so we can fix it.',
            'review-box.thumbs-down-after' : 'Why is this solution not clear?',
            'review-box.thumbs-down-after-drop-down-aria-description' : 'Drop down menu. Please press tab to select a reason',
            'review-box.thumbs-down-after-clicked' : 'Thanks. We use your feedback to update incomplete or inaccurate content. Keep it coming.',
            'review-box.thumbs-down-description' : '%{thumbdown} people thought this solution was not helpful. Give this solution a thumbs down?',
            'review-box.additional-details-required' : 'Additional details (required)',
            'review-box.additional-details-optional' : 'Additional details (optional)',
            'review-box.submit' : 'Submit',
            'review-box.cancel' : 'Cancel',
            'comments.submit' : 'Submit',
            'comments.comments-count' : [
                [0, 0, 'Comment'],
                [1, null, 'Comments (%n)']
            ],
            'comments.remove' : 'Remove Comment',
            'no-sub.problem-info' : 'Chapter %{chapter}, problem %{problem_name} is solved.',
            'no-sub.subtitle' : '',
            'no-sub.cta-button-text' : 'View full solution',
            'no-sub.sample-solution' : 'View sample solution',
            'no-sub.free-access-exceeded' : 'You\'ve reached the limit of 3 free solutions',
            'no-sub.free-access-cta' : 'Click here to subscribe',
            'error.network-title' : 'Sorry, something went wrong. Try refreshing the page.',
            'error.network-description' : '<ErrorCode.%{code}>',
            'error.reload-btn' : 'Reload page'
        },
        contexts:[
            {
                "matches":{
                    "problem_exists" : true
                },
                "values":{
                    "solution.title" : "Step-by-step solution",
                    "toolbar.name" : "Chapter %{chapter_name}, Problem %{problem_name}"
                }
            },
            {
                "matches":{
                    "problem_exists" : false
                },
                "values":{
                    "solution.title" : "Problem not found",
                    "toolbar.name" : "Chapter %{chapter_name}"
                }
            }

        ]
    }
};

export function getLocale(ln='en'){
    return i18n.create(defs[ln]);
}

export function addLocale(ln, config){
    defs[ln] = config;
}



// WEBPACK FOOTER //
// ./src/helpers/locale.js